export default __webpack_public_path__ + "static/sa-b8315d8a2b264f143135167a51eb337d.svg";